import { c as _c } from "react/compiler-runtime";
import React from "react";
import DropPartMarkdownWithPropLogger from "@/components/drops/view/part/DropPartMarkdownWithPropLogger";
import WaveDropQuoteWithDropId from "./WaveDropQuoteWithDropId";
import EditDropLexical from "./EditDropLexical";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import type { ApiDrop } from "@/generated/models/ApiDrop";
interface WaveDropPartContentMarkdownProps {
  readonly mentionedUsers: Array<ApiDropMentionedUser>;
  readonly mentionedWaves: Array<ApiMentionedWave>;
  readonly referencedNfts: Array<ApiDropReferencedNFT>;
  readonly part: ApiDropPart;
  readonly wave: ApiWaveMin;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly drop?: ApiDrop | undefined; // Add drop to check for edited status
}
const WaveDropPartContentMarkdown: React.FC<WaveDropPartContentMarkdownProps> = t0 => {
  const $ = _c(38);
  const {
    mentionedUsers,
    mentionedWaves,
    referencedNfts,
    part,
    wave,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    drop
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== drop || $[1] !== wave) {
    t3 = drop?.serial_no === undefined ? [] : [`${wave.id}:${drop.serial_no}`];
    $[0] = drop;
    $[1] = wave;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const currentQuotePath = t3;
  if (isEditing) {
    const t4 = part.content ?? "";
    let t5;
    if ($[3] !== onSave) {
      t5 = (content, mentions, waves) => {
        if (onSave) {
          onSave(content, mentions, waves);
        }
      };
      $[3] = onSave;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== onCancel) {
      t6 = () => {
        if (onCancel) {
          onCancel();
        }
      };
      $[5] = onCancel;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== isSaving || $[8] !== mentionedUsers || $[9] !== mentionedWaves || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== wave.id) {
      t7 = <EditDropLexical initialContent={t4} initialMentions={mentionedUsers} initialWaveMentions={mentionedWaves} waveId={wave.id} isSaving={isSaving} onSave={t5} onCancel={t6} />;
      $[7] = isSaving;
      $[8] = mentionedUsers;
      $[9] = mentionedWaves;
      $[10] = t4;
      $[11] = t5;
      $[12] = t6;
      $[13] = wave.id;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  const t4 = drop?.id;
  const t5 = drop?.hide_link_preview;
  let t6;
  if ($[15] !== currentQuotePath || $[16] !== mentionedUsers || $[17] !== mentionedWaves || $[18] !== onQuoteClick || $[19] !== part.content || $[20] !== referencedNfts || $[21] !== t4 || $[22] !== t5) {
    t6 = <DropPartMarkdownWithPropLogger mentionedUsers={mentionedUsers} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} partContent={part.content} onQuoteClick={onQuoteClick} currentDropId={t4} hideLinkPreviews={t5} quotePath={currentQuotePath} />;
    $[15] = currentQuotePath;
    $[16] = mentionedUsers;
    $[17] = mentionedWaves;
    $[18] = onQuoteClick;
    $[19] = part.content;
    $[20] = referencedNfts;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== drop) {
    t7 = drop?.updated_at && drop.updated_at !== drop.created_at && <div className="tw-mt-0.5 tw-text-[10px] tw-font-normal tw-leading-none tw-text-iron-500">(edited)</div>;
    $[24] = drop;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t6 || $[27] !== t7) {
    t8 = <div>{t6}{t7}</div>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== currentQuotePath || $[30] !== drop || $[31] !== onQuoteClick || $[32] !== part.quoted_drop || $[33] !== wave) {
    t9 = part.quoted_drop?.drop_id && <div className="tw-mt-1.5"><WaveDropQuoteWithDropId dropId={part.quoted_drop.drop_id} partId={part.quoted_drop.drop_part_id} maybeDrop={part.quoted_drop.drop ? {
        ...part.quoted_drop.drop,
        wave
      } : null} onQuoteClick={onQuoteClick} embedPath={drop?.id ? [drop.id] : []} quotePath={currentQuotePath} embedDepth={1} /></div>;
    $[29] = currentQuotePath;
    $[30] = drop;
    $[31] = onQuoteClick;
    $[32] = part.quoted_drop;
    $[33] = wave;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== t8 || $[36] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[35] = t8;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
};
export default WaveDropPartContentMarkdown;